import { Box, makeStyles } from '@material-ui/core';
import { ArrowsChevronRight, Children, TextBlock } from 'neon-design-system';
import { RequestStatus } from '../../constants/request';
import { RequestStatusLabel } from '../RequestStatusLabel/RequestStatusLabel';

const useStyles = makeStyles((theme) => ({
    box: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '&:active': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)'
        },
        gap: theme.spacing(1)
    },
    productWrapper: {
        flex: 1,
        minWidth: 0,
        '& > *': {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    productName: {
        marginBottom: theme.spacing(0.5)
    },
    statusWrapper: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1)
    }
}));

interface ClickableListItemProps {
    title?: string;
    titleComponent?: JSX.Element;
    onClick?: () => void;
    subtitle?: string | JSX.Element;
    children?: Children;
    status?: RequestStatus;
    statusComponent?: JSX.Element;
}

export const ClickableListItem = ({
    title,
    titleComponent,
    onClick,
    subtitle,
    children,
    status,
    statusComponent
}: ClickableListItemProps) => {
    const classes = useStyles();

    return (
        <Box className={classes.box} onClick={onClick}>
            <div className={classes.productWrapper}>
                {titleComponent ? (
                    titleComponent
                ) : (
                    <TextBlock className={classes.productName}>
                        <strong>{title}</strong>
                    </TextBlock>
                )}
                <TextBlock styleName="caption1" ink="muted">
                    {subtitle || children}
                </TextBlock>
            </div>
            <div className={classes.statusWrapper}>
                {statusComponent ? statusComponent : <RequestStatusLabel status={status!} />}
                {onClick && <ArrowsChevronRight />}
            </div>
        </Box>
    );
};
